/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class UpdateViewerRoleRequest {
  'roleId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "roleId",
      "baseName": "roleId",
      "type": "string",
      "format": "tobedefined"
    }  ];

  static getAttributeTypeMap() {
    return UpdateViewerRoleRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

